class GiftWrapping extends HTMLElement {
  constructor() {
    super();
    this.handles = this.getAttribute('handles').split(',') || [];
    this.select = this.querySelector('disclosure-select');
    this.products = [];
    this.init();
  }

  connectedCallback() {
    this.select.addEventListener('change', this.handleSelection.bind(this));
  }

  async init() {
    await this.fetchGiftWrappingProducts();
    this.populateOptions();
  }

  async fetchGiftWrappingProducts() {
    const rootUrl = window.Shopify.routes.root === '/' ? '/' : window.Shopify.routes.root + '/';
    const promises = this.handles.map(productHandle => fetch(`${rootUrl}products/${productHandle}.js`));
    const settledPromises = await Promise.allSettled(promises);

    for (const promise of settledPromises) {
      try {
        const res = await promise.value;
        if (res.status !== 200) throw res.status;
        const json = await res.json();
        this.products.push(json);
      } catch (err) {
        console.error(err);
      }
    }
  }

  populateOptions() {
    const listElement = this.querySelector('.disclosure__list');
    let html = '';

    this.products.forEach(product => {
      const { title, variants, featured_image } = product;
      const variant = variants[0];

      if (!variant.available) return;

      const price = variant.price == 0 ? window.variantStrings.gift_wrapping.free : Woolman.Utils.formatMoney(variant.price);
      const compareAtPrice = variant.compare_at_price && variant.compare_at_price > variant.price
        ? Woolman.Utils.formatMoney(variant.compare_at_price)
        : '';

      html += `
        <li class="disclosure__item" role="option">
          <div class="gift-wrapping__item disclosure__link" data-value="${variant.id}" data-label="${title} - ${price}" data-name="${title}">
            <div class="gift-wrapping__info">
              <h3 class="gift-wrapping__title">${title}</h3>
              <p class="gift-wrapping__price">
                ${compareAtPrice ? `<span style="text-decoration: line-through">${compareAtPrice}</span>` : ''}
                ${price}
              </p>
              <span class="gift-wrapping__selection mt-16 fw-bold">
                <span class="radio mr-8"></span>
                <span>${window.variantStrings.gift_wrapping.yes}</span>
              </span>
            </div>
            <div class="gift-wrapping__image">
              <img src="${featured_image}" alt="${title}" loading="lazy" decoding="async" /> 
            </div>
          </div>
        </li>`;
    });

    if (html !== '') {
      listElement.insertAdjacentHTML('beforeend', html);
      this.removeAttribute('hidden');
    }
  }

  handleSelection(event) {
    this.select.querySelector('.disclosure-current').innerHTML = event.detail.element.dataset.label;
  }
}

if (!customElements.get('gift-wrapping')) {
  customElements.define('gift-wrapping', GiftWrapping);
}
